import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { history, Prompt, Location } from 'umi';
import { Modal, ConfirmOptions } from 'tea-component';

interface IRoutePromptProps extends ConfirmOptions {
  // 是否进行路由拦截
  when: boolean;
}

const RoutePrompt: React.FC<IRoutePromptProps> = (props) => {
  const { style, className, when, okText = 'Confirm', cancelText = 'Cancel', onOk, onCancel, ...restProps } = props;

  // 即将跳转路由的location，二次弹窗确认，用户点击Confirm后，把路由临时保存起来
  const [location, setLocation] = useState<Location<unknown>>();

  /**
   * location有值后，进行路由跳转
   */
  useEffect(() => {
    if (!location) return;
    history.push(location);
  }, [location]);

  return (
    <Prompt
      // when为true，并且没有location时，表示路由切换时要进行拦截，并进行二次确认提示交互
      when={when && !location}
      message={(location) => {
        /**
         * 让当前获取焦点的元素 丢失焦点
         * 在二次确认弹窗打开时，浏览器会把焦点从当前激活元素转移到弹窗中，会触发当前元素的onBlur事件，并且在关闭弹窗后，浏览器又会把焦点从弹窗转移回之前那个元素，从而会再次触发那个元素的onFocus事件
         * 在上面的场景下，在特殊的业务代码下，可能会造成无限循环，关闭弹窗后，立马又弹窗的问题
         * 所以在二次确认弹窗唤起后，需要让当前激活的元素失去焦点
         */
        (document.activeElement as HTMLElement)?.blur();
        Modal.confirm({
          ...restProps,
          className: classnames('dbg-route-guide-modal', className),
          okText,
          cancelText,
          onOk: () => {
            onOk?.();
            setLocation(location);
          },
          onCancel: () => {
            onCancel?.();
          },
        });
        return false;
      }}
    />
  );
};

export default RoutePrompt;
